export let headers = { "Content-Type": "application/json" };

async function Call(url, method, body) {

  const config = body !== null ? {
    method: method,
    headers: getHeaders(),
    body: JSON.stringify(body),
  } : {
    method: method,
    headers: getHeaders(),
  }
  
  const res = await fetch(url, config);
  if (!res.ok) {
    return {success: false, data: null};
  } else {
    const result = await res.json();
    return {success: true, data: result};   
  }
};

export function setHeaders(params){
  headers = params;
}

export function getHeaders() {
  return headers;
} 


export async function Post(url, body) {
  return await Call(url, 'POST', body);
}

export async function Get(url) {
  return await Call(url, 'GET', null);
}

export async function Put(url, body) {
  return await Call(url, 'PUT', body);
}

export async function Patch(url, body) {
  return await Call(url, 'PATCH', body);
}

export async function Delete(url, body) {
  return await Call(url, 'DELETE', body);
}
